import {Injectable} from "@angular/core";
import {Environment} from "../environment/environment";

@Injectable()
export class ApiRouteConfig {
  constructor(
      private readonly environment: Environment,
  ) {
  }

  public get SYSTEM_STATUS() {
    return '/system-status.json';
  }

  public get TRANSLATION() {
    return `${this.environment.apiUrl}api/translations/`;
  }

  public get LANGUAGES() {
    return `${this.environment.apiUrl}api/businessRules/availableLanguages`;
  }

  public get UPDATE_PASSWORD() {
    return `${this.environment.apiUrl}account/updatePassword`;
  }

  public get AGREE_LICENSE() {
    return `${this.environment.apiUrl}api/license/agreeLicense/{0}`;
  }

  public get GET_LOGIN_BY_CONFIRMATION_CODE() {
    return `${this.environment.apiUrl}account/login/`;
  }

  public get ACCOUNT_FORGOT_PASSWORD() {
    return `${this.environment.apiUrl}account/forgotPassword/`;
  }

  public get ACCOUNT_VERIFY_RESET_PASSWORD_CODE() {
    return `${this.environment.apiUrl}account/verifyResetPasswordCode/`;
  }

  public get ACCOUNT_CONFIRM_FORGOT_PASSWORD() {
    return `${this.environment.apiUrl}account/confirmForgotPassword/`;
  }

  public get ACCOUNT_RESEND_CONFIRMATION_EMAIL() {
    return `${this.environment.apiUrl}account/resendConfirmationEmail/`;
  }

  public get LOGIN_MAGIC_LINK_TOKEN() {
    return `${this.environment.apiUrl}account/magicLinkToken/{0}`;
  }

  public get ACCOUNTS() {
    return `${this.environment.apiUrl}api/logins`;
  }

  public get ACCOUNTS_BY_DBO_LOGIN() {
    return `${this.environment.apiUrl}api/logins/byDboLogin`;
  }

  public get ACCOUNT_DETAILS() {
    return `${this.environment.apiUrl}api/logins/{0}`;
  }

  public get ACCOUNT_INVITE() {
    return `${this.environment.apiUrl}api/logins/{0}/invite`;
  }

  public get ACCOUNT_BUILDING_ROLES() {
    return `${this.environment.apiUrl}api/logins/{0}/buildingRole`;
  }

  public get ACCOUNT_BUILDING_ROLES_DELETE() {
    return `${this.environment.apiUrl}api/logins/{0}/buildingRole/{1}`;
  }

  public get ACCOUNT_NEW_FROM_CONTACT() {
    return `${this.environment.apiUrl}api/logins/fromContact`;
  }

  public get ACCOUNT_GENERATE_APITOKEN() {
    return `${this.environment.apiUrl}api/logins/{0}/apiToken`;
  }

  public get ACCOUNT_GET_APITOKEN() {
    return `${this.environment.apiUrl}api/logins/{0}/apiToken`;
  }

  public get ACCOUNT_GET_PARTNER() {
    return `${this.environment.apiUrl}api/logins/{0}/partner`;
  }

  public get LOGINS_USERNAME_VALIDATION() {
    return `${this.environment.apiUrl}api/logins/usernameValidation`;
  }

  public get PAYMENT_OVERVIEW() {
    return `${this.environment.apiUrl}api/payment`;
  }

  public get PAYMENT_ORDER_SUMMARY() {
    return `${this.environment.apiUrl}api/payment/orderSummary`;
  }

  public get PAYMENT_SUBSCRIPTION_SUMMARY() {
    return `${this.environment.apiUrl}api/payment/subscriptionsummary`;
  }

  public get PAYMENT_CONFIRM_BUSINESS() {
    return `${this.environment.apiUrl}api/payment/confirmBusiness`;
  }

  public get PAYMENT_ACTIVATE_SUBSCRIPTION() {
    return `${this.environment.apiUrl}api/payment/activatesubscription`;
  }

  public get RECURRING_PAYMENT_METHOD_ACTIVE() {
    return `${this.environment.apiUrl}api/recurringPaymentMethod/active`;
  }

  public get RECURRING_PAYMENT_METHOD_DEACTIVATE() {
    return `${this.environment.apiUrl}api/recurringPaymentMethod/deactivate`;
  }

  public get PAYMENT_COMPLETED_TRANSACTION_HISTORY() {
    return `${this.environment.apiUrl}api/orders/completed`;
  }

  public get PAYMENT_DOWNLOAD_ORDER_INVOICE() {
    return `${this.environment.apiUrl}api/orders/{0}/invoicePdf`;
  }

  public get BUILDINGS() {
    return `${this.environment.apiUrl}api/building`;
  }

  public get BUILDING_GET() {
    return `${this.environment.apiUrl}api/building/{0}`;
  }

  public get BUILDING_ADD() {
    return `${this.environment.apiUrl}api/building/createBuilding`;
  }

  public get BUILDINGS_PRISTINE() {
    return `${this.environment.apiUrl}api/building/pristine`;
  }

  public get BUILDING_ADDRESS() {
    return `${this.environment.apiUrl}api/building/{0}/address`;
  }

  public get BUILDING_PHOTOS() {
    return `${this.environment.apiUrl}api/building/{0}/urls`;
  }

  public get BUILDING_COVER() {
    return `${this.environment.apiUrl}api/building/{0}/coverUrl`;
  }

  public get BUILDING_COPY() {
    return `${this.environment.apiUrl}api/building/{0}/copy`;
  }

  public get BUILDING_DOCUMENTS() {
    return `${this.environment.apiUrl}api/building/{0}/document`;
  }

  public get BUILDING_DOCUMENTS_UPDATE() {
    return `${this.environment.apiUrl}api/building/{0}/document`;
  }

  public get BUILDING_DOCUMENTS_FILE() {
    return `${this.environment.apiUrl}api/building/{0}/document/file`;
  }

  public get BUILDING_DOCUMENTS_FILE_UPDATE() {
    return `${this.environment.apiUrl}api/building/{0}/document/{1}/file`;
  }

  public get BUILDING_DOCUMENTS_DELETE() {
    return `${this.environment.apiUrl}api/building/{0}/document/{1}`;
  }

  public get BUILDING_ISSUES() {
    return `${this.environment.apiUrl}api/building/{0}/issues`;
  }

  public get BUILDING_ISSUES_EXPORT() {
    return `${this.environment.apiUrl}api/issues/export`;
  }

  public get BUILDING_ISSUES_EXPORT_BY_IDS() {
    return `${this.environment.apiUrl}api/issues/exportByIds`;
  }

  public get BUILDING_ISSUES_MERGE() {
    return `${this.environment.apiUrl}api/issues/merge`;
  }

  public get BUILDING_ISSUES_RESOLVE() {
    return `${this.environment.apiUrl}api/issues/resolve`;
  }

  public get BUILDING_ISSUE_RESOLVE() {
    return `${this.environment.apiUrl}api/issues/{0}/resolve`;
  }

  public get BUILDING_ISSUE_CANCEL() {
    return `${this.environment.apiUrl}api/issues/{0}/cancel`;
  }

  public get BUILDING_ISSUE_SNOOZE() {
    return `${this.environment.apiUrl}api/issues/{0}/snooze`;
  }

  public get BUILDING_ISSUES_DETAILS_EXPORT() {
    return `${this.environment.apiUrl}api/building/{0}/issues/export`;
  }

  public get BUILDING_ISSUES_DETAILS() {
    return `${this.environment.apiUrl}api/issues`;
  }

  public get BUILDING_ISSUES_DETAILS_ID() {
    return `${this.environment.apiUrl}api/issues/{0}`;
  }

  public get BUILDING_ISSUES_DETAILS_LOGS() {
    return `${this.environment.apiUrl}api/issues/{0}/log`;
  }

  public get BUILDING_ISSUES_DETAILS_MEDIA() {
    return `${this.environment.apiUrl}api/issues/{0}/media`;
  }

  public get BUILDING_ISSUES_DETAILS_PHOTO() {
    return `${this.environment.apiUrl}api/issues/{0}/photo`;
  }

  public get BUILDING_ISSUES_DETAILS_VIDEO() {
    return `${this.environment.apiUrl}api/multimedia/issues/{0}/video`;
  }

  public get BUILDING_ISSUES_DETAILS_MEDIA_DELETE() {
    return `${this.environment.apiUrl}api/issues/{0}/media/{1}`;
  }

  public get BUILDING_ISSUES_DETAILS_ACTIONS() {
    return `${this.environment.apiUrl}api/issues/{0}/actions`;
  }

  public get BUILDING_ISSUES_OBSERVATION_VALUES() {
    return `${this.environment.apiUrl}api/issues/issueObservationValues`;
  }

  public get BUILDING_ISSUE_REPORT() {
    return `${this.environment.apiUrl}api/issues/{0}/generateIssueReport`;
  }

  public get BUILDING_ISSUES_REPORT() {
    return `${this.environment.apiUrl}api/issues/generateIssuesReport`;
  }

  //public get BUILDING_METERS() { return this.environment.apiUrl + 'api/building/{0}/meters'; }

  public get BUILDING_ACTIONS() {
    return `${this.environment.apiUrl}api/building/{0}/action`;
  }

  //public get BUILDING_METERS_EXPORT() { return this.environment.apiUrl + 'api/building/{0}/meters/export'; }
  public get BUILDING_JOB_CREATE_URL() {
    return `${this.environment.apiUrl}api/jobs/createUrl`;
  }

  public get BUILDING_JOB_COMPLETE() {
    return `${this.environment.apiUrl}api/jobs/complete`;
  }

  public get BUILDING_JOB_LOGS() {
    return `${this.environment.apiUrl}api/jobs/{0}/logs`;
  }

  public get BUILDING_INSPECTIONS() {
    return `${this.environment.apiUrl}api/building/{0}/inspections`;
  }

  public get BUILDING_INSPECTION_METRICS() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/metrics`;
  }

  public get BUILDING_INSPECTION_DOCUMENTS() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/documents`;
  }

  public get BUILDING_INSPECTION_DOCUMENT_DOWNLOAD() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/documents/{2}`;
  }

  public get BUILDING_INSPECTION_DOCUMENT_GENERATION() {
    return `${this.environment.apiUrl}api/inspections/{0}/reQueueReportGeneration`;
  }

  public get BUILDING_INSPECTION_DOCUMENT_GENERATION_STATUS() {
    return `${this.environment.apiUrl}api/inspections/report-generation/{0}/status`;
  }

  public get BUILDING_INSPECTION_DETAILS() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}`;
  }

  public get BUILDING_INSPECTION_CHECKPOINTS() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/inspectionCheckpoints`;
  }

  public get BUILDING_INSPECTION_SETWITHOUTCONSEQUENCES() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/setWithoutConsequences`;
  }

  public get BUILDING_INSPECTION_CHECKPOINT() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/inspectionCheckpoints/{2}`;
  }

  public get BUILDING_INSPECTION_CHECKPOINT_MEDIA() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/inspectionCheckpoints/{2}/multimediums`;
  }

  public get BUILDING_INSPECTION_CHECKPOINT_ISSUES() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/inspectionCheckpoints/{2}/issues`;
  }

  public get BUILDING_INSPECTION_CHECKPOINTS_ISSUES() {
    return `${this.environment.apiUrl}api/building/{0}/inspections/{1}/inspectionCheckpoints/addMultipleIssues`;
  }

  public get BUILDING_SUBSTRUCTURES_LOCATION() {
    return `${this.environment.apiUrl}api/building/{0}/substructuresLocation`;
  }

  public get BUILDING_PRIVATE_UNITS() {
    return `${this.environment.apiUrl}api/building/{0}/privateUnits`;
  }

  public get BUILDING_STRUCTURE() {
    return `${this.environment.apiUrl}api/building/{0}/structure`;
  }

  public get BUILDING_STRUCTURE_DETAILS() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}`;
  }

  public get BUILDING_STRUCTURE_CHILDREN() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/child`;
  }

  public get BUILDING_STRUCTURE_LOCATION_ELEMENTS() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/elements`;
  }

  public get BUILDING_STRUCTURE_ELEMENT_GROUPS() {
    return `${this.environment.apiUrl}api/building/elementgroups`;
  }

  public get BUILDING_STRUCTURE_CHILDREN_TEMPLATES() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/childTemplates`;
  }

  public get BUILDING_STRUCTURE_ADD_CHILDREN() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/addChildStructure`;
  }

  public get BUILDING_STRUCTURE_CHECKPOINTS() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/checkPoints`;
  }

  public get BUILDING_STRUCTURE_DELETE_CHECKPOINTS() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/checkPoints/delete`;
  }

  public get BUILDING_STRUCTURE_ADD_ELEMENT() {
    return `${this.environment.apiUrl}api/building/{0}/element`;
  }

  public get BUILDING_STRUCTURE_UPDATE_ELEMENT() {
    return `${this.environment.apiUrl}api/building/{0}/element/{1}`;
  }

  public get BUILDING_STRUCTURE_DELETE_ELEMENT() {
    return `${this.environment.apiUrl}api/building/{0}/element/{1}`;
  }

  public get BUILDING_STRUCTURE_ADD_FLOOR() {
    return `${this.environment.apiUrl}api/building/{0}/layer`;
  }

  public get BUILDING_STRUCTURE_GET_FLOORS() {
    return `${this.environment.apiUrl}api/building/{0}/layer`;
  }

  public get BUILDING_STRUCTURE_GET_FLOORS_ALL() {
    return `${this.environment.apiUrl}api/building/{0}/layer/all`;
  }

  public get BUILDING_STRUCTURE_GET_FLOOR_TEMPLATES() {
    return `${this.environment.apiUrl}api/building/{0}/buildingLayerProposals`;
  }

  public get BUILDING_STRUCTURE_SUMMARY() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/summary`;
  }

  public get BUILDING_STRUCTURE_REORDER() {
    return `${this.environment.apiUrl}api/building/{0}/reorderStructures`;
  }

  public get BUILDING_STRUCTURE_COPY() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/copy`;
  }

  public get BUILDING_STRUCTURE_CONTACTS() {
    return `${this.environment.apiUrl}api/building/{0}/structure/{1}/contact`;
  }

  public get BUILDING_CONTACTS() {
    return `${this.environment.apiUrl}api/building/{0}/contacts`;
  }

  public get BUILDING_METRICS() {
    return `${this.environment.apiUrl}api/building/{0}/buildingMetrics`;
  }

  public get BUILDING_STATE_REPORT() {
    return `${this.environment.apiUrl}api/building/{0}/state`;
  }

  public get BUILDING_CHECKLIST() {
    return `${this.environment.apiUrl}api/checklists/{0}`;
  }

  public get BUILDING_CHECKLIST_TYPES() {
    return `${this.environment.apiUrl}api/checklists/checklistTypes`;
  }

  public get BUILDING_CHECKLIST_CHECKPOINTS() {
    return `${this.environment.apiUrl}api/checkpoints`;
  }

  public get BUILDING_CHECKLIST_CHECKPOINTS_DUPLICATE() {
    return `${this.environment.apiUrl}api/checkpoints/duplicate`;
  }

  public get BUILDING_CHECKLISTS() {
    return `${this.environment.apiUrl}api/checklists/building/{0}`;
  }

  public get BUILDING_CHECKLIST_VISIBILITY() {
    return `${this.environment.apiUrl}api/checklists/building/{0}/visible`;
  }

  public get BUILDING_CHECKLISTS_NODE_ADD() {
    return `${this.environment.apiUrl}api/checklists/node`;
  }

  public get BUILDING_CHECKLISTS_NODE_UPDATE() {
    return `${this.environment.apiUrl}api/checklists/node`;
  }

  public get BUILDING_CHECKLISTS_NODE_DUPLICATE() {
    return `${this.environment.apiUrl}api/checklists/node/{0}/duplicateNode`;
  }

  public get BUILDING_CHECKLISTS_NODE_PHOTO() {
    return `${this.environment.apiUrl}api/multimedia/checklist/{0}/photo`;
  }

  public get BUILDING_CHECKLISTS_NODE_DOCUMENT() {
    return `${this.environment.apiUrl}api/multimedia/checklist/{0}/document`;
  }

  public get BUILDING_CHECKLISTS_NODE_VIDEO() {
    return `${this.environment.apiUrl}api/multimedia/checklist/{0}/video`;
  }

  public get BUILDING_CHECKLISTS_NODE_MEDIA_DELETE() {
    return `${this.environment.apiUrl}api/multimedia/checklist/{0}/{1}`;
  }

  public get BUILDING_CHECKLISTS_DUPLICATE() {
    return `${this.environment.apiUrl}api/checklists/node/{0}/duplicate`;
  }

  public get BUILDING_CHECKLISTS_NODES_SORT() {
    return `${this.environment.apiUrl}api/checklists/node/{0}/sort`;
  }

  public get BUILDING_CHECKLISTS_NODE_DELETE() {
    return `${this.environment.apiUrl}api/checklists/node/{0}`;
  }

  public get BUILDING_CHECKLISTS_CHECKPOINT_ADD() {
    return `${this.environment.apiUrl}api/checklistnodecheckpoints`;
  }

  public get BUILDING_CHECKLISTS_CHECKPOINT_UPDATE() {
    return `${this.environment.apiUrl}api/checklistnodecheckpoints`;
  }

  public get BUILDING_CHECKLISTS_CHECKPOINT_DELETE() {
    return `${this.environment.apiUrl}api/checklistnodecheckpoints/{0}`;
  }

  public get BUILDING_CHECKLISTS_CHECKPOINTS_SORT() {
    return `${this.environment.apiUrl}api/checklistnodecheckpoints/sort`;
  }

  public get BUSINESS_RULES_DEFAULT_PERMISSIONS() {
    return `${this.environment.apiUrl}api/businessRules/permissions/default`;
  }

  public get BUSINESS_RULES_ISSUE_TYPES() {
    return `${this.environment.apiUrl}api/businessRules/availableIssueTypes`;
  }

  public get BUSINESS_RULES_ISSUE_CATEGORIES_TYPES() {
    return `${this.environment.apiUrl}api/businessRules/availableIssueCategoriesWithTypes`;
  }

  public get BUSINESS_RULES_STRUCTURE_ELEMENT_TYPES() {
    return `${this.environment.apiUrl}api/businessRules/structureElementTypes`;
  }

  public get BUSINESS_RULES_COUNTRIES_AND_STATES() {
    return `${this.environment.apiUrl}api/businessRules/countriesAndStates`;
  }

  public get BUSINESS_RULES_PERMISSIONS_BY_PRODUCT() {
    return `${this.environment.apiUrl}api/businessRules/availablePermissionsByProduct`;
  }

  public get BUSINESS_FEATURE_FLAGS() {
    return `${this.environment.apiUrl}api/business/features`;
  }

  public get CONTACTS() {
    return `${this.environment.apiUrl}api/contacts`;
  }

  public get CONTACTS_IMPORT_VALIDATION() {
    return `${this.environment.apiUrl}api/contacts/importValidation`;
  }

  public get CONTACTS_IMPORT() {
    return `${this.environment.apiUrl}api/contacts/import`;
  }

  public get CONTACT() {
    return `${this.environment.apiUrl}api/contacts/{0}`;
  }

  public get CONTACT_AVATAR() {
    return `${this.environment.apiUrl}api/contacts/{0}/avatar`;
  }

  public get CONTACT_FULLNAME_BY_LOGIN() {
    return `${this.environment.apiUrl}api/contacts/fullName`;
  }

  public get CONTACT_FUNCTIONS() {
    return `${this.environment.apiUrl}api/contacts/{0}/functionRole`;
  }

  public get CONTACT_LOCATIONS() {
    return `${this.environment.apiUrl}api/contacts/{0}/locations`;
  }

  public get CONTACT_FUNCTIONS_DELETE() {
    return `${this.environment.apiUrl}api/contacts/{0}/functionRole/{1}`;
  }

  public get CONTACT_DOCUMENTS() {
    return `${this.environment.apiUrl}api/contacts/{0}/document`;
  }

  public get CONTACT_DOCUMENTS_FILE() {
    return `${this.environment.apiUrl}api/contacts/{0}/document/file`;
  }

  public get CONTACT_DOCUMENT_DELETE() {
    return `${this.environment.apiUrl}api/contacts/{0}/document/{1}`;
  }

  public get CONTACT_INTERVENTION_TEAMS() {
    return `${this.environment.apiUrl}api/contacts/{0}/interventionTeams`;
  }

  public get CONTACT_FAVOURITE() {
    return `${this.environment.apiUrl}api/contacts/{0}/favorite`;
  }

  public get CONTACT_GDPR_REPORT() {
    return `${this.environment.apiUrl}api/contacts/{0}/gdprReport`;
  }

  public get CONTACT_IS_RESIDENT() {
    return `${this.environment.apiUrl}api/contacts/{0}/isResident`;
  }

  public get FLOORPLAN() {
    return `${this.environment.apiUrl}api/floorplan/{0}`;
  }

  public get STRUCTURE_FLOORPLAN() {
    return `${this.environment.apiUrl}api/floorplan/structure/{0}`;
  }

  public get FLOORPLAN_CREATE() {
    return `${this.environment.apiUrl}api/floorplan`;
  }

  public get FLOORPLAN_MARKERS() {
    return `${this.environment.apiUrl}api/floorplan/{0}/markers`;
  }

  public get ISSUE_MARKERS() {
    return `${this.environment.apiUrl}api/floorplan/markers/{0}`;
  }

  /**
   * RESIDENZ API ENDPOINTS
   */
  public get RESIDENTS() {
    return `${this.environment.residenzUrl}api/resident`;
  }

  public get RESIDENT_BUILDINGS() {
    return `${this.environment.residenzUrl}api/building/{0}`;
  }

  public get RESIDENT_BUILDING_TEMPLATE_LOCATIONS() {
    return `${this.environment.residenzUrl}api/templateLocation`;
  }

  public get RESIENT_NOTIFICATIONS() {
    return `${this.environment.residenzUrl}api/notification`;
  }

  /**
   * MAINTENANCE API ENDPOINTS
   */
  public get MAINTENANCE_ACTIONS() {
    return `${this.environment.apiUrl}api/jobs`;
  }

  public get METER_DETAILS() {
    return `${this.environment.apiUrl}api/meters/{0}`;
  }

  public get METERS() {
    return `${this.environment.apiUrl}api/meters`;
  }

  public get METERS_EXPORT() {
    return `${this.environment.apiUrl}api/meters/export`;
  }

  public get METERS_EXPORT_BY_IDS() {
    return `${this.environment.apiUrl}api/meters/exportByIds`;
  }

  public get METERS_IMPORT() {
    return `${this.environment.apiUrl}api/meters/import`;
  }

  public get METERS_IMPORT_VALIDATION() {
    return `${this.environment.apiUrl}api/meters/importValidation`;
  }

  public get METERS_READINGS() {
    return `${this.environment.apiUrl}api/meters/{0}/readings`;
  }

  public get ERROR_HANDLER() {
    return `${this.environment.apiUrl}api/errorHandler`;
  }

  public get ROLE() {
    return `${this.environment.apiUrl}api/role`;
  }

  public get ROLE_DELETE() {
    return `${this.environment.apiUrl}api/role/{0}`;
  }

  public get ROLE_PERMISSION() {
    return `${this.environment.apiUrl}api/role/{0}/permission`;
  }

  public get ROLE_PERMISSION_DELETE() {
    return `${this.environment.apiUrl}api/role/{0}/permission/{1}`;
  }

  public get PERMISSIONS() {
    return `${this.environment.apiUrl}api/role/permissionGroup `;
  }

  public get REPORT_SETTINGS_DEFAULT() {
    return `${this.environment.apiUrl}api/businessRules/defaultReportBusinessSettings`;
  }

  public get REPORT_SETTINGS_LOGO() {
    return `${this.environment.apiUrl}api/reportSettings/logo`;
  }

  public get REPORT_SETTINGS_FONTS() {
    return `${this.environment.apiUrl}api/reportSettings/fonts`;
  }

  public get REPORT_SETTINGS_PAPER_FORMATS() {
    return `${this.environment.apiUrl}api/reportSettings/paperFormats`;
  }

  public get REPORT_SETTINGS_PAPER_FORMAT() {
    return `${this.environment.apiUrl}api/reportSettings/paperFormat`;
  }

  public get REPORT_SETTINGS_REPORT_SETTINGS_LAYOUT() {
    return `${this.environment.apiUrl}api/reportSettings/layout`;
  }

  public get BUSINESS() {
    return `${this.environment.apiUrl}api/business`;
  }

  public get BUSINESS_DISPLAYMESSAGESETTINGS() {
    return `${this.environment.apiUrl}api/business/displayMessageSettings`;
  }

  public get BUSINESS_PRODUCTS() {
    return `${this.environment.apiUrl}api/business/products`;
  }

  public get DEVICES() {
    return `${this.environment.apiUrl}api/devices`;
  }

  public get DEVICE() {
    return `${this.environment.apiUrl}api/devices/{0}`;
  }

  public get INSPECTIONS() {
    return `${this.environment.apiUrl}api/inspections`;
  }

  public get INSPECTION_EXECUTORS() {
    return `${this.environment.apiUrl}api/inspections/inspectionExecutors`;
  }

  public get INSPECTION_TYPES() {
    return `${this.environment.apiUrl}api/inspections/inspectionTypes/{0}`;
  }

  public get INSPECTION_LOGS() {
    return `${this.environment.apiUrl}api/inspections/{0}/inspectionLogs`;
  }

  public get INSPECTION_DETAIL() {
    return `${this.environment.apiUrl}api/inspections/{0}`;
  }

  public get INSPECTION_CANCEL() {
    return `${this.environment.apiUrl}api/inspections/{0}/cancel`;
  }

  public get INSPECTION_MULTIMEDIA() {
    return `${this.environment.apiUrl}api/inspections/{0}/multimedia`;
  }

  public get INSPECTION_MAIL_REMINDERS() {
    return `${this.environment.apiUrl}api/inspections/{0}/mailReminder`;
  }

  public get INSPECTION_MAIL_REMINDER() {
    return `${this.environment.apiUrl}api/inspections/{0}/mailReminder/{1}`;
  }

  public get INTERVENTION_TEAMS() {
    return `${this.environment.apiUrl}api/interventionTeams`;
  }

  public get INTERVENTION_TEAMS_SEARCH() {
    return `${this.environment.apiUrl}api/interventionTeams/search`;
  }

  public get INTERVENTION_TEAMS_ALL() {
    return `${this.environment.apiUrl}api/interventionTeams/all`;
  }

  public get INTERVENTION_TEAMS_DETAILS() {
    return `${this.environment.apiUrl}api/interventionTeams/details`;
  }

  public get INTERVENTION_TEAMS_ACTION() {
    return `${this.environment.apiUrl}api/interventionTeams/{0}/actions`;
  }

  public get INTERVENTION_TEAM_DETAIL() {
    return `${this.environment.apiUrl}api/interventionTeams/{0}`;
  }

  public get INTERVENTION_TEAM_CONTACT() {
    return `${this.environment.apiUrl}api/interventionTeams/{0}/contact/{1}`;
  }

  public get JOBS_ASSIGN() {
    return `${this.environment.apiUrl}api/jobs/{0}/assign/{1}`;
  }

  public get JOBS_UNASSIGN() {
    return `${this.environment.apiUrl}api/jobs/{0}/unassign`;
  }

  public get JOBS_ASSIGN_WITH_PRIORITY() {
    return `${this.environment.apiUrl}api/jobs/{0}/assign/{1}?priority={2}`;
  }

  public get JOBS_SEND() {
    return `${this.environment.apiUrl}api/jobs/{0}/send`;
  }

  public get JOBS_GET_ALL() {
    return `${this.environment.apiUrl}api/jobs`;
  }

  public get JOBS_UPDATE_STATUS() {
    return `${this.environment.apiUrl}api/jobs/{0}/status`;
  }

  public get REGISTER_ACCOUNT() {
    return `${this.environment.apiUrl}account/registerBusiness`;
  }

  public get FEEDBACK() {
    return `${this.environment.apiUrl}api/feedback`;
  }

  public get PRIORITIZE_ACTION() {
    return `${this.environment.apiUrl}api/interventions/prioritizeAction`;
  }

  public get ASSIGN_ACTIONS() {
    return `${this.environment.apiUrl}api/interventions/assignAction`;
  }

  public get ACTION_BUSINESS_RULES() {
    return `${this.environment.apiUrl}api/businessRules/interventionsBusinessRules`;
  }

  public get NOTIFICATIONS() {
    return `${this.environment.apiUrl}api/notification`;
  }

  public get NOTIFICATIONS_AP() {
    return `${this.environment.apiUrl}api/notification/attentionPoints`;
  }

  public get NOTIFICATIONS_ISSUE() {
    return `${this.environment.apiUrl}api/notification/issues`;
  }

  public get APPLICATIONS_ROUTE() {
    return `${this.environment.accountSiteUrl}api/applications`;
  }

  public get PARTNERS_SEARCH_PARTNERCLIENT() {
    return `${this.environment.apiUrl}api/partners/clients?pageNumber={0}&pageSize={1}`;
  }

  public get PARTNERS_GET_ALL() {
    return `${this.environment.apiUrl}api/partners`;
  }

  public get PARTNERS_ADD_PARTNERCLIENT() {
    return `${this.environment.apiUrl}api/partners/{0}`;
  }

  public get PARTNERS_UPD_PARTNERCLIENT() {
    return `${this.environment.apiUrl}api/partners/{0}`;
  }

  public get PARTNERS_PARTNERCLIENT_STARTIMPORT() {
    return `${this.environment.apiUrl}api/partners/{0}/start`;
  }

  public get PARTNERS_PARTNERCLIENT_IMPORTSTATUS() {
    return `${this.environment.apiUrl}api/partners/{0}/latestImportRunFinished`;
  }

  public get MULTIMEDIA_DOWNLOAD() {
    return `${this.environment.apiUrl}api/multimedia/download`;
  }

  public get MULTIMEDIA_DELETE() {
    return `${this.environment.apiUrl}api/multimedia/{0}`;
  }

  public get GET_LICENSE() {
    return `${this.environment.apiUrl}api/license/{0}`;
  }

  public get ACTIVE_SYSTEM_NOTIFICATION() {
    return `${this.environment.apiUrl}api/system-notifications/active`;
  }

  public get DELETE_MAINTENANCE_ACTION() {
    return `${this.environment.apiUrl}api/jobs/{0}`;
  }

  public get SEND_MAINTENANCE_ACTIONS() {
    return `${this.environment.apiUrl}api/jobs/sendAllActions/{0}`;
  }

  public get MAINTENANCE_INTERVENTION_TEAMS() {
    return `${this.environment.apiUrl}api/interventionTeams`;
  }

  public get MAINTENANCE_CONTACTS() {
    return `${this.environment.apiUrl}api/interventionTeamContacts`;
  }

  public get RESIDENZ_LOCATIONS() {
    return `${this.environment.apiUrl}api/building/{0}/locations?applicationType=Building`;
  }

  public get STRUCTURE_DETAILS() {
    return `${this.environment.apiUrl}api/structure/{0}`;
  }
  public get STRUCTURE_CHILDREN() {
    return `${this.environment.apiUrl}api/structure/{0}/children`;
  }

  public get TOUR_ATTENDANCE() {
    return `${this.environment.apiUrl}api/settings/product-tour`
  }

  public getRouteWithInjectedParams(route: string, values: RouteParam[]): string {
    let result: string = route;
    for (let i = 0; i < values.length; i++) {
      result = result.replace(`{${i}}`, values[i] as string);
    }
    return result;
  }


}

type RouteParam = string | number;
